module.exports = { count: 100000000, rate: 0.8 };
